import css from "./HeaderGeral.module.css"

function HeaderGeral(){
    return (
        <div className={`${css.header}`}>
            <div className={"d-flex justify-content-center align-items-center"}>
                <img className={css.logogeral} src="/logop.jpg" alt=""/>
            </div>
            <nav className={"d-flex justify-content-between align-items-center gap-3 gap-sm-5 text-center"}>
                <a className={css.link} href="/">SOBRE NÓS</a>
                <a className={css.link} href="/tratamentos">TRATAMENTOS</a>
                <a className={css.link} href="/contatos">CONTATOS</a>
            </nav>
        </div>
    )
}

export default HeaderGeral;